import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_conta } from "../../../models";

export const Conta = () => {
    const columns = [
        { field: 'condescricao', header: 'Descrição' },
        { field: 'contipo', header: 'Tipo', body: (e: any) => <div>{e?.contipo === 0 ? 'INTERNA' : 'BANCÁRIA'}</div> },
        { field: 'banco.bancodescricao', header: 'Banco' },
        { field: 'connumero', header: 'Número' },
        { field: 'conagencia', header: 'Agância' },
        { field: 'condigito', header: 'Dígito' },
        { field: 'conativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    return (
        <ConsultaPadrao model={model_conta} columns={columns} />
    )
}